/* eslint-disable @typescript-eslint/ban-types */
import gql from "graphql-tag";
import type { Observable } from "rxjs";
import type { DocumentNode } from "graphql";

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
};

export type AsyncTask = {
  completedAt?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  errorMsg?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  startedAt?: Maybe<Scalars["DateTime"]>;
  status: AsyncTaskStatus;
  taskType: AsyncTaskType;
  updatedAt: Scalars["DateTime"];
};

export type AsyncTaskStatus = "Completed" | "Failed" | "Pending";

export type AsyncTaskType = "BuildDownload" | "TranscodeLocalVideo";

export type BatchCommand = {
  payload?: InputMaybe<Scalars["JSON"]>;
  type: StoryCommandType;
};

export type BuildDownloadTask = AsyncTask & {
  __typename?: "BuildDownloadTask";
  completedAt?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  downloadUrl?: Maybe<Scalars["String"]>;
  errorMsg?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  startedAt?: Maybe<Scalars["DateTime"]>;
  status: AsyncTaskStatus;
  taskType: AsyncTaskType;
  updatedAt: Scalars["DateTime"];
  userId?: Maybe<Scalars["ID"]>;
};

export type CursorPaginatedStoryState = {
  __typename?: "CursorPaginatedStoryState";
  cursor?: Maybe<Scalars["String"]>;
  data: StoryState;
  total: Scalars["Float"];
};

export type LoginResponse = {
  __typename?: "LoginResponse";
  access_token: Scalars["String"];
};

export type Mutation = {
  __typename?: "Mutation";
  executeBatch: Array<StoryEvent>;
  login: LoginResponse;
  updateAsyncTask: AsyncTask;
};

export type MutationExecuteBatchArgs = {
  autoHandleConflicts?: InputMaybe<Scalars["Boolean"]>;
  commands: Array<BatchCommand>;
  storyId: Scalars["String"];
};

export type MutationLoginArgs = {
  password: Scalars["String"];
  username: Scalars["String"];
  visitorId: Scalars["String"];
};

export type MutationUpdateAsyncTaskArgs = {
  data: UpdateAsyncTaskData;
};

export type OrganizationOpts = {
  __typename?: "OrganizationOpts";
  managerViewAll: Scalars["Boolean"];
};

export type PaginatedStories = {
  __typename?: "PaginatedStories";
  items: Array<Story>;
  page: Scalars["Float"];
  pageSize: Scalars["Float"];
  total: Scalars["Float"];
};

export type Query = {
  __typename?: "Query";
  asyncTasks: Array<AsyncTask>;
  stories: PaginatedStories;
  story: Story;
};

export type QueryAsyncTasksArgs = {
  status?: InputMaybe<AsyncTaskStatus>;
  type?: InputMaybe<AsyncTaskType>;
  updatedBefore?: InputMaybe<Scalars["DateTime"]>;
};

export type QueryStoriesArgs = {
  ids?: InputMaybe<Array<Scalars["String"]>>;
  pageInfo: WrappedPageInfo;
  queryType?: InputMaybe<StoriesQueryType>;
};

export type QueryStoryArgs = {
  id: Scalars["String"];
};

export type StoriesQueryType = "ById" | "ByUser";

/** Story Desc */
export type Story = {
  __typename?: "Story";
  asyncTaskCount: Scalars["Int"];
  author: Scalars["ID"];
  description?: Maybe<Scalars["String"]>;
  featureFlags: Scalars["JSON"];
  id: Scalars["ID"];
  registeredParticipants: Array<Scalars["ID"]>;
  state: CursorPaginatedStoryState;
  title?: Maybe<Scalars["String"]>;
};

/** Story Desc */
export type StoryAsyncTaskCountArgs = {
  status?: InputMaybe<AsyncTaskStatus>;
  type?: InputMaybe<AsyncTaskType>;
};

/** Story Desc */
export type StoryStateArgs = {
  cursor?: InputMaybe<Scalars["String"]>;
  limit?: InputMaybe<Scalars["Float"]>;
};

export type StoryCommandType =
  | "DETERMINE_LOCAL_RECORDING_CAPABILITY"
  | "DETERMINE_PARTICIPANT_QUOTA"
  | "JOIN_CALL"
  | "LEAVE_CALL"
  | "OVERRIDE_PARTICIPANT_LOCAL_RECORDING"
  | "SEND_CHAT_MESSAGE"
  | "SEND_LOCAL_RECORDING_PART_DONE_RECORDING"
  | "SEND_LOCAL_RECORDING_PART_INFO"
  | "SEND_LOCAL_RECORDING_PART_UPLOAD_COMPLETED"
  | "SEND_LOCAL_RECORDING_PART_UPLOAD_FAILED"
  | "SEND_LOCAL_RECORDING_PART_UPLOAD_PROGRESS"
  | "SEND_LOCAL_RECORDING_UPLOAD_COMPLETED"
  | "SEND_LOCAL_RECORDING_UPLOAD_FAILED"
  | "SEND_PARTICIPANT_CHAT_PRESENCE"
  | "SET_AUDIO_ENABLED"
  | "SET_PARTICIPANT_NAME"
  | "SET_VIDEO_ENABLED"
  | "START_CALL_LOCAL_RECORDING"
  | "START_PARTICIPANT_LOCAL_RECORDING"
  | "STOP_CALL_LOCAL_RECORDING"
  | "STOP_PARTICIPANT_LOCAL_RECORDING";

/** Describing an event that happened during a particular session */
export type StoryEvent = {
  __typename?: "StoryEvent";
  batch_id: Scalars["ID"];
  batch_sequence: Scalars["ID"];
  createdAt: Scalars["DateTime"];
  id: Scalars["ID"];
  payload?: Maybe<Scalars["JSON"]>;
  sender: StoryEventSender;
  type?: Maybe<StoryEventType>;
};

export type StoryEventParticipantGuestSender = {
  __typename?: "StoryEventParticipantGuestSender";
  type: Scalars["String"];
  visitorId: Scalars["String"];
};

export type StoryEventParticipantUserSender = {
  __typename?: "StoryEventParticipantUserSender";
  type: Scalars["String"];
  userId: Scalars["String"];
  visitorId: Scalars["String"];
};

export type StoryEventSender =
  | StoryEventParticipantGuestSender
  | StoryEventParticipantUserSender
  | StoryEventServerSender;

export type StoryEventServerSender = {
  __typename?: "StoryEventServerSender";
  type: Scalars["String"];
};

export type StoryEventType =
  | "AUDIO_ENABLED_SET"
  | "CALL_LOCAL_RECORDING_STARTED"
  | "CALL_LOCAL_RECORDING_STOPPED"
  | "CHAT_MESSAGE_SENT"
  | "JOINED_CALL"
  | "LEFT_CALL"
  | "LOCAL_RECORDING_CAPABILITY_DETERMINED"
  | "LOCAL_RECORDING_PART_DONE_RECORDING"
  | "LOCAL_RECORDING_PART_INFO_SENT"
  | "LOCAL_RECORDING_PART_UPLOAD_COMPLETED_SENT"
  | "LOCAL_RECORDING_PART_UPLOAD_FAILED_SENT"
  | "LOCAL_RECORDING_PART_UPLOAD_PROGRESS_SENT"
  | "LOCAL_RECORDING_UPLOAD_COMPLETED_SENT"
  | "LOCAL_RECORDING_UPLOAD_FAILED_SENT"
  | "PARTICIPANT_CHAT_PRESENCE_SENT"
  | "PARTICIPANT_LOCAL_RECORDING_OVERRIDDEN"
  | "PARTICIPANT_LOCAL_RECORDING_STARTED"
  | "PARTICIPANT_LOCAL_RECORDING_STOPPED"
  | "PARTICIPANT_NAME_SET"
  | "PARTICIPANT_QUOTA_DETERMINED"
  | "REJOINED_CALL"
  | "VIDEO_ENABLED_SET";

/** The state of a story, including information about its participants */
export type StoryState = {
  __typename?: "StoryState";
  aggregate: Scalars["JSON"];
  events: Array<StoryEvent>;
};

export type Subscription = {
  __typename?: "Subscription";
  asyncTaskUpdated: AsyncTask;
  watchStoryAsyncTasks: AsyncTask;
  watchStoryState: CursorPaginatedStoryState;
};

export type SubscriptionAsyncTaskUpdatedArgs = {
  taskId: Scalars["String"];
};

export type SubscriptionWatchStoryAsyncTasksArgs = {
  storyIds: Array<Scalars["String"]>;
  type?: InputMaybe<AsyncTaskType>;
};

export type SubscriptionWatchStoryStateArgs = {
  id: Scalars["String"];
};

export type TranscodeLocalVideoTask = AsyncTask & {
  __typename?: "TranscodeLocalVideoTask";
  completedAt?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  errorMsg?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  jobId: Scalars["String"];
  startedAt?: Maybe<Scalars["DateTime"]>;
  status: AsyncTaskStatus;
  storyId: Scalars["String"];
  taskType: AsyncTaskType;
  updatedAt: Scalars["DateTime"];
};

export type UpdateAsyncTaskData = {
  responseData?: InputMaybe<Scalars["JSON"]>;
  status?: InputMaybe<AsyncTaskStatus>;
  taskId: Scalars["String"];
};

export type WrappedPageInfo = {
  current: Scalars["Int"];
  size: Scalars["Int"];
};

export type GetStoriesQueryVariables = Exact<{
  page: Scalars["Int"];
  count: Scalars["Int"];
}>;

export type GetStoriesQuery = {
  __typename?: "Query";
  stories: {
    __typename?: "PaginatedStories";
    page: number;
    total: number;
    items: Array<{
      __typename?: "Story";
      id: string;
      title?: string | null;
      description?: string | null;
      featureFlags: any;
      state: { __typename?: "CursorPaginatedStoryState"; data: { __typename?: "StoryState"; aggregate: any } };
    }>;
  };
};

export type GetStoryAsyncTaskCountQueryVariables = Exact<{
  storyId: Scalars["String"];
  type?: InputMaybe<AsyncTaskType>;
  status?: InputMaybe<AsyncTaskStatus>;
}>;

export type GetStoryAsyncTaskCountQuery = {
  __typename?: "Query";
  story: { __typename?: "Story"; asyncTaskCount: number };
};

export type UpdateStoryStateMutationVariables = Exact<{
  storyId: Scalars["String"];
  commands: Array<BatchCommand> | BatchCommand;
}>;

export type UpdateStoryStateMutation = {
  __typename?: "Mutation";
  executeBatch: Array<{
    __typename?: "StoryEvent";
    id: string;
    type?: StoryEventType | null;
    payload?: any | null;
    createdAt: any;
    batch_id: string;
    sender:
      | { __typename?: "StoryEventParticipantGuestSender"; type: string; visitorId: string }
      | { __typename?: "StoryEventParticipantUserSender"; type: string; visitorId: string; userId: string }
      | { __typename?: "StoryEventServerSender"; type: string };
  }>;
};

export type WatchStorySubscriptionVariables = Exact<{
  storyId: Scalars["String"];
}>;

export type WatchStorySubscription = {
  __typename?: "Subscription";
  watchStoryState: {
    __typename?: "CursorPaginatedStoryState";
    cursor?: string | null;
    total: number;
    data: { __typename?: "StoryState"; aggregate: any };
  };
};

export type WatchAsyncTaskSubscriptionVariables = Exact<{
  taskId: Scalars["String"];
}>;

export type WatchAsyncTaskSubscription = {
  __typename?: "Subscription";
  asyncTaskUpdated:
    | {
        __typename: "BuildDownloadTask";
        downloadUrl?: string | null;
        status: AsyncTaskStatus;
        errorMsg?: string | null;
      }
    | { __typename: "TranscodeLocalVideoTask"; status: AsyncTaskStatus; errorMsg?: string | null };
};

export type WatchActiveTasksOnStoriesSubscriptionVariables = Exact<{
  stories: Array<Scalars["String"]> | Scalars["String"];
}>;

export type WatchActiveTasksOnStoriesSubscription = {
  __typename?: "Subscription";
  watchStoryAsyncTasks:
    | { __typename: "BuildDownloadTask"; id: string; taskType: AsyncTaskType; status: AsyncTaskStatus }
    | {
        __typename: "TranscodeLocalVideoTask";
        storyId: string;
        id: string;
        taskType: AsyncTaskType;
        status: AsyncTaskStatus;
      };
};

export const GetStories = gql`
  query getStories($page: Int!, $count: Int!) {
    stories(pageInfo: { current: $page, size: $count }) {
      page
      total
      items {
        id
        title
        description
        featureFlags
        state {
          data {
            aggregate
          }
        }
      }
    }
  }
`;
export const GetStoryAsyncTaskCount = gql`
  query getStoryAsyncTaskCount($storyId: String!, $type: AsyncTaskType, $status: AsyncTaskStatus) {
    story(id: $storyId) {
      asyncTaskCount(type: $type, status: $status)
    }
  }
`;
export const UpdateStoryState = gql`
  mutation updateStoryState($storyId: String!, $commands: [BatchCommand!]!) {
    executeBatch(storyId: $storyId, commands: $commands, autoHandleConflicts: true) @polling {
      id
      sender {
        ... on StoryEventParticipantUserSender {
          type
          visitorId
          userId
        }
        ... on StoryEventParticipantGuestSender {
          type
          visitorId
        }
        ... on StoryEventServerSender {
          type
        }
      }
      type
      payload
      createdAt
      batch_id
    }
  }
`;
export const WatchStory = gql`
  subscription watchStory($storyId: String!) {
    watchStoryState(id: $storyId) {
      cursor
      total
      data {
        aggregate
      }
    }
  }
`;
export const WatchAsyncTask = gql`
  subscription watchAsyncTask($taskId: String!) {
    asyncTaskUpdated(taskId: $taskId) {
      __typename
      status
      errorMsg
      ... on BuildDownloadTask {
        downloadUrl
      }
    }
  }
`;
export const WatchActiveTasksOnStories = gql`
  subscription watchActiveTasksOnStories($stories: [String!]!) {
    watchStoryAsyncTasks(storyIds: $stories) {
      id
      taskType
      status
      __typename
      ... on TranscodeLocalVideoTask {
        storyId
      }
    }
  }
`;

export const GetStoriesDocument = gql`
  query getStories($page: Int!, $count: Int!) {
    stories(pageInfo: { current: $page, size: $count }) {
      page
      total
      items {
        id
        title
        description
        featureFlags
        state {
          data {
            aggregate
          }
        }
      }
    }
  }
`;
export const GetStoryAsyncTaskCountDocument = gql`
  query getStoryAsyncTaskCount($storyId: String!, $type: AsyncTaskType, $status: AsyncTaskStatus) {
    story(id: $storyId) {
      asyncTaskCount(type: $type, status: $status)
    }
  }
`;
export const UpdateStoryStateDocument = gql`
  mutation updateStoryState($storyId: String!, $commands: [BatchCommand!]!) {
    executeBatch(storyId: $storyId, commands: $commands, autoHandleConflicts: true) @polling {
      id
      sender {
        ... on StoryEventParticipantUserSender {
          type
          visitorId
          userId
        }
        ... on StoryEventParticipantGuestSender {
          type
          visitorId
        }
        ... on StoryEventServerSender {
          type
        }
      }
      type
      payload
      createdAt
      batch_id
    }
  }
`;
export const WatchStoryDocument = gql`
  subscription watchStory($storyId: String!) {
    watchStoryState(id: $storyId) {
      cursor
      total
      data {
        aggregate
      }
    }
  }
`;
export const WatchAsyncTaskDocument = gql`
  subscription watchAsyncTask($taskId: String!) {
    asyncTaskUpdated(taskId: $taskId) {
      __typename
      status
      errorMsg
      ... on BuildDownloadTask {
        downloadUrl
      }
    }
  }
`;
export const WatchActiveTasksOnStoriesDocument = gql`
  subscription watchActiveTasksOnStories($stories: [String!]!) {
    watchStoryAsyncTasks(storyIds: $stories) {
      id
      taskType
      status
      __typename
      ... on TranscodeLocalVideoTask {
        storyId
      }
    }
  }
`;
export type Requester<C = {}> = <R, V>(doc: DocumentNode, vars?: V, options?: C) => Promise<R> & Observable<R>;
export function getSdk<C>(requester: Requester<C>) {
  return {
    getStories(variables: GetStoriesQueryVariables, options?: C): Promise<GetStoriesQuery> {
      return requester<GetStoriesQuery, GetStoriesQueryVariables>(GetStoriesDocument, variables, options);
    },
    getStoryAsyncTaskCount(
      variables: GetStoryAsyncTaskCountQueryVariables,
      options?: C
    ): Promise<GetStoryAsyncTaskCountQuery> {
      return requester<GetStoryAsyncTaskCountQuery, GetStoryAsyncTaskCountQueryVariables>(
        GetStoryAsyncTaskCountDocument,
        variables,
        options
      );
    },
    updateStoryState(variables: UpdateStoryStateMutationVariables, options?: C): Promise<UpdateStoryStateMutation> {
      return requester<UpdateStoryStateMutation, UpdateStoryStateMutationVariables>(
        UpdateStoryStateDocument,
        variables,
        options
      );
    },
    watchStory(variables: WatchStorySubscriptionVariables, options?: C): Observable<WatchStorySubscription> {
      return requester<WatchStorySubscription, WatchStorySubscriptionVariables>(WatchStoryDocument, variables, options);
    },
    watchAsyncTask(
      variables: WatchAsyncTaskSubscriptionVariables,
      options?: C
    ): Observable<WatchAsyncTaskSubscription> {
      return requester<WatchAsyncTaskSubscription, WatchAsyncTaskSubscriptionVariables>(
        WatchAsyncTaskDocument,
        variables,
        options
      );
    },
    watchActiveTasksOnStories(
      variables: WatchActiveTasksOnStoriesSubscriptionVariables,
      options?: C
    ): Observable<WatchActiveTasksOnStoriesSubscription> {
      return requester<WatchActiveTasksOnStoriesSubscription, WatchActiveTasksOnStoriesSubscriptionVariables>(
        WatchActiveTasksOnStoriesDocument,
        variables,
        options
      );
    },
  };
}
export type Sdk = ReturnType<typeof getSdk>;
